import { css } from '@emotion/react';
import Mixin from '../../../util/mixin';


export class SrOnly extends Mixin {
  style() {
    return css`
      position: absolute;
      width: 1px;
      height: 1px;
      padding: 0;
      margin: -1px; /* Fix for https://github.com/twbs/bootstrap/issues/25686 */
      overflow: hidden;
      clip: rect(0, 0, 0, 0);
      white-space: nowrap;
      border: 0;
    `;
  }
}

export class SrOnlyFocusable extends Mixin {
  style() {
    return css`
      &:active,
      &:focus {
        position: static;
        width: auto;
        height: auto;
        overflow: visible;
        clip: auto;
        white-space: normal;
      }
    `;
  }
}
